export default __webpack_public_path__ + "static/media/Delete.aec83627.svg";